import { render } from "./RepoBI.vue?vue&type=template&id=183febd8&scoped=true"
import script from "./RepoBI.vue?vue&type=script&lang=js"
export * from "./RepoBI.vue?vue&type=script&lang=js"

import "./RepoBI.vue?vue&type=style&index=0&id=183febd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183febd8"]])

export default __exports__